export default {"src":"/_next/static/media/cherry-logo.855da4de.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};